(() => {
  const cart = () => document.querySelector('[data-cart-drawer]');
  const search = () => document.querySelector('[data-search-panel]');
  const cartURL = () => new URL(document.body.dataset.cartUrl || '/cart', location.origin);
  let busy = false;
  const triggers = new WeakMap();
  const closingAnimations = new WeakMap();
  function closeDialog(dialog) {
    if (!dialog?.open) return;
    if (!dialog.matches('[data-search-panel]') || matchMedia('(prefers-reduced-motion: reduce)').matches) { dialog.close(); return; }
    if (closingAnimations.has(dialog)) return;
    dialog.dataset.closing = 'true';
    const animation = dialog.animate([{transform:getComputedStyle(dialog).transform,opacity:1},{transform:'translateY(-110%)',opacity:0}], {duration:240,easing:'cubic-bezier(.4,0,.2,1)',fill:'forwards'});
    closingAnimations.set(dialog,animation);
    animation.finished.then(()=>{if(closingAnimations.get(dialog)!==animation)return;dialog.close();delete dialog.dataset.closing;closingAnimations.delete(dialog);animation.cancel();}).catch(()=>{});
  }
  function open(dialog, trigger) {
    if (!dialog) return;
    const closing = closingAnimations.get(dialog); if (closing) {closing.cancel();closingAnimations.delete(dialog);delete dialog.dataset.closing;}
    document.querySelectorAll('dialog[open]').forEach(other => { if (other !== dialog) closeDialog(other); });
    if (trigger) triggers.set(dialog, trigger);
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('hf-dialog-open');
  }
  function announce(text) { const status = document.getElementById('CartStatus'); if (status) status.textContent = text; }
  function error(text) { document.querySelectorAll('[data-cart-error], [data-cart-page-error]').forEach(output => output.textContent = text); if (text) announce(text); }
  function setBusy(value) {
    busy = value;
    const drawer = cart();
    drawer?.setAttribute('aria-busy', String(value));
    document.querySelectorAll('[data-qty-control] input, [data-qty-control] button, [name="checkout"], .hf-cart-page [name="update"]').forEach(el => el.disabled = value);
  }
  async function refresh(html, pageHTML) {
    if (!html) {
      const url = cartURL(); url.searchParams.set('section_id', 'cart-drawer');
      const response = await fetch(url, {headers: {'X-Requested-With':'XMLHttpRequest'}, credentials:'same-origin', cache:'no-store'});
      if (!response.ok) throw new Error('Unable to refresh your bag.');
      html = await response.text();
    }
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
    const drawer = cart();
    if (!fresh || !drawer) throw new Error('Unable to refresh your bag.');
    // Keep the dialog itself mounted so its focus trap and open state survive updates.
    drawer.innerHTML = fresh.innerHTML;
    drawer.dataset.count = fresh.dataset.count;
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = fresh.dataset.count || '0');
    const page = document.querySelector('[data-cart-page-section]');
    if (page) {
      const note = page.querySelector('[name="note"]')?.value;
      if (!pageHTML) {
        const url = cartURL(); url.searchParams.set('section_id',page.dataset.cartPageSection);
        const response = await fetch(url, {credentials:'same-origin',cache:'no-store'});
        if (!response.ok) throw new Error('Unable to refresh cart page.');
        pageHTML = await response.text();
      }
      const freshPage = new DOMParser().parseFromString(pageHTML,'text/html').querySelector('[data-cart-page-section]');
      if (!freshPage) throw new Error('Unable to refresh cart page.');
      page.replaceWith(freshPage);
      if (note != null && freshPage.querySelector('[name="note"]')) freshPage.querySelector('[name="note"]').value = note;
    }
    setBusy(busy);
  }
  async function change(key, quantity, focusName, scope) {
    if (busy) return;
    const sourceIsPage = !!scope?.closest('[data-cart-page-section]');
    const source = sourceIsPage ? document.querySelector('[data-cart-page-section]') : cart();
    const activeInput = [...(source?.querySelectorAll('[data-qty-control]') || [])].find(el => el.dataset.cartKey === key)?.querySelector('input');
    const oldQuantity = activeInput?.defaultValue;
    setBusy(true); error('');
    try {
      const url = cartURL(); url.pathname = url.pathname.replace(/\/$/, '') + '/change.js';
      const pageId = document.querySelector('[data-cart-page-section]')?.dataset.cartPageSection;
      const response = await fetch(url, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:key, quantity, sections:['cart-drawer',pageId].filter(Boolean), sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Could not update this item.');
      try { await refresh(result.sections?.['cart-drawer'],result.sections?.[pageId]); }
      catch (_) { error('Your bag was updated. Close and reopen Bag to refresh the totals.'); return; }
      setBusy(false);
      announce('Your bag has been updated.');
      const updatedScope = sourceIsPage ? document.querySelector('[data-cart-page-section]') : cart();
      const target = [...updatedScope.querySelectorAll('[data-qty-control]')].find(el => el.dataset.cartKey === key);
      (target?.querySelector(focusName || 'input') || updatedScope.querySelector('a, button'))?.focus();
    } catch (err) {
      if (activeInput && oldQuantity != null) activeInput.value = oldQuantity;
      error(err.message || 'Connection failed. Please try again.');
    } finally { setBusy(false); }
  }
  function initSearch(scope = document) {
    scope.querySelectorAll('[data-search-panel] form').forEach(form => {
      if (form.dataset.searchReady) return;
      form.dataset.searchReady = 'true';
      const input = form.querySelector('input[type="search"]');
      const results = form.querySelector('[data-predictive-search]');
      const status = form.querySelector('[data-search-status]');
      let timer, controller, generation = 0;
      function reset() { clearTimeout(timer); controller?.abort(); generation++; results.hidden = true; results.innerHTML = ''; status.textContent = ''; input.removeAttribute('aria-busy'); }
      input.addEventListener('input', () => {
        reset();
        const q = input.value.trim();
        if (q.length < 2) return;
        const current = generation;
        timer = setTimeout(async () => {
          controller = new AbortController(); input.setAttribute('aria-busy','true');
          try {
            const fallback = cartURL().pathname.replace(/\/cart\/?$/, '/search/suggest');
            const url = new URL(document.body.dataset.predictiveUrl || fallback, location.origin);
            url.search = new URLSearchParams({q, 'resources[type]':'product,collection,page', 'resources[limit]':'6', section_id:'predictive-search'}).toString();
            const response = await fetch(url, {signal:controller.signal, headers:{'X-Requested-With':'XMLHttpRequest'},credentials:'same-origin'});
            if (!response.ok) throw new Error('Search suggestions are unavailable. Press Search to see results.');
            const html = await response.text();
            if (generation !== current) return;
            results.innerHTML = html; results.hidden = !results.textContent.trim();
            status.textContent = 'Search suggestions updated.';
          } catch (err) { if (err.name !== 'AbortError' && generation === current) status.textContent = 'Search suggestions are unavailable. Press Search to see results.'; }
          finally { if (generation === current) input.removeAttribute('aria-busy'); }
        },180);
      });
      input.addEventListener('keydown', event => { if (event.key === 'ArrowDown' && !results.hidden) { event.preventDefault(); results.querySelector('a')?.focus(); } });
      form.addEventListener('keydown', event => {
        if (!['ArrowDown','ArrowUp'].includes(event.key) || event.target === input) return;
        const links = [...results.querySelectorAll('a')]; const i = links.indexOf(document.activeElement);
        if (i < 0) return;
        event.preventDefault();
        if (event.key === 'ArrowUp' && i === 0) input.focus();
        else links[(i + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length]?.focus();
      });
      form.closest('dialog').addEventListener('close', reset);
      form.closest('dialog').addEventListener('cancel',event=>{event.preventDefault();closeDialog(form.closest('dialog'));});
    });
  }
  document.addEventListener('click', async event => {
    const target = event.target;
    const searchOpen = target.closest('[data-search-open]');
    if (searchOpen && search()) { event.preventDefault(); open(search(),searchOpen); search().querySelector('input[type="search"]')?.focus(); return; }
    if (target.closest('[data-search-close]')) { closeDialog(search()); return; }
    const cartOpen = target.closest('[data-cart-open]');
    if (cartOpen && cart()) {
      event.preventDefault(); open(cart(),cartOpen);
      if (!busy) { setBusy(true); try { await refresh(); cart().querySelector('[data-cart-close]')?.focus(); } catch (_) { error('Unable to refresh your bag. Please try again or view the cart page.'); } finally { setBusy(false); } }
      return;
    }
    if (target.closest('[data-cart-close]')) { cart()?.close(); return; }
    if (target.matches('dialog[data-cart-drawer], dialog[data-search-panel]')) {
      const rect = target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(target);
    }
    const remove = target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); if (!busy) await change(remove.dataset.cartKey,0,undefined,remove); return; }
    const button = target.closest('[data-qty-minus], [data-qty-plus]');
    if (!button || busy) return;
    const control = button.closest('[data-qty-control]'); const input = control.querySelector('input');
    const step = Number(input.step) || 1, minimum = Number(input.dataset.min) || 1;
    let quantity = Number(input.value) + (button.hasAttribute('data-qty-plus') ? step : -step);
    if (quantity > 0 && quantity < minimum) quantity = button.hasAttribute('data-qty-plus') ? minimum : 0;
    if (input.max && quantity > Number(input.max)) return;
    await change(control.dataset.cartKey, Math.max(0,quantity),button.hasAttribute('data-qty-plus') ? '[data-qty-plus]' : '[data-qty-minus]',button);
  });
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-qty-control] input');
    if (!input || busy) return;
    const quantity = Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 0 || (quantity > 0 && quantity < Number(input.dataset.min || 1)) || !input.checkValidity()) { error('Please enter a valid quantity.'); input.value = input.defaultValue; return; }
    change(input.closest('[data-cart-key]').dataset.cartKey,quantity,undefined,input);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const dialog = document.querySelector('[data-search-panel][open], [data-cart-drawer][open]');
    if (dialog) { event.preventDefault(); closeDialog(dialog); }
    const item = event.target.closest('.desktop-nav .nav-item');
    if (item) { item.classList.add('nav-closed'); item.querySelector('.nav-parent')?.focus(); }
  });
  document.addEventListener('pointerover', event => event.target.closest('.nav-item')?.classList.remove('nav-closed'));
  document.addEventListener('focusout', event => { const item = event.target.closest('.nav-item'); if (item && !item.contains(event.relatedTarget)) item.classList.remove('nav-closed'); });
  document.addEventListener('close', event => {
    if (!event.target.matches('dialog')) return;
    if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('hf-dialog-open');
    const trigger = triggers.get(event.target); if (!document.querySelector('dialog[open]') && trigger?.isConnected && !trigger.closest('dialog:not([open])')) trigger.focus();
  },true);
  document.addEventListener('shopify:section:load', event => initSearch(event.target));
  window.HanifaCart = {refresh,open:trigger => open(cart(),trigger)};
  initSearch();
})();
